import React from 'react';
import {Blog} from 'FW/Models/Blog';
import {File as FWFile} from 'FW/Models/File';
import moment from 'moment';
import Pagination from 'react-js-pagination';
import _ from 'underscore';
import '../../../../_lib/dotdotdot/dist/jquery.dotdotdot';
import InlineEditableElement from '../../../Components/InlineEditableElement';

class BlogView extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = this.getStateFromProps(props);
    if (
      this.state.checkedTags.length > 0 ||
      this.state.checkedCategories.length > 0
    ) {
      this.state.posts.addQuery({
        tags: this.state.checkedTags.length > 0 ? this.state.checkedTags : null,
        categories:
          this.state.checkedCategories.length > 0
            ? this.state.checkedCategories
            : null
      });
    }

    this.state.posts.setPageSize(
      props.section.prop('number_of_posts') || 5,
      () => {
        this.forceUpdate();
      }
    );
    if (FW.inEditor()) {
      this.addButtonToSection();
    }
  }

  addButtonToSection() {
    let section = this.props.section;
    let user = window.parent.FW.store.get('user')
      ? window.parent.FW.store.get('user')
      : null;
    if (user && user.may('edit_blog', this.state.blog)) {
      section._editButtons = [
        {
          title: 'Add Blog Post',
          class: 'glyphicon-plus',
          type: 'btn-default',
          action: () => {
            window.parent.FW.editor.setMode('editBlog', 'addPost', {
              blog: this.state.blog
            });
          }
        }
      ];
    }
  }

  componentDidMount() {
    if (this.props.section.prop('auto_load_more')) {
      $(window).on('scroll', () => {
        let bottom = $(this._bottom);
        let windowBottom = $(window).scrollTop() + $(window).height();
        if (
          bottom.offset().top < windowBottom &&
          this.state.posts.pagination.size <
            this.state.posts.pagination.total &&
          !this.loadingMore
        ) {
          this.loadingMore = true;
          this.state.posts.loadMore().then(() => {
            this.forceUpdate();
          });
        }
      });
    }

    // better text truncation
    clearTimeout(this.dotdotdot);
    if (!this.props.section.prop('display_full_posts_in_preview')) {
      this.dotdotdot = setTimeout(() => {
        $('.post-content-new').dotdotdot();
      }, 50);
    }

    if (FW.inEditor()) window.parent.FW.editor.addType('blog', this.state.blog);
  }

  componentDidUpdate() {
    if (
      this.state.posts.pagination &&
      this.state.posts.pagination.number !== this.pageNumber
    ) {
      this.pageNumber = this.state.posts.pagination.number;
    }
    clearTimeout(this.dotdotdot);
    if (!this.props.section.prop('display_full_posts_in_preview')) {
      this.dotdotdot = setTimeout(() => {
        $('.post-content-new').dotdotdot();
      }, 50);
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState(this.getStateFromProps(newProps));
  }

  getStateFromProps(props) {
    let blog = Blog.findOrCreate({id: props.section.prop('blog_id')});
    let tagsRegEx = new RegExp('tags/([0-9,]*)');
    let tagMatches = window.location.hash.match(tagsRegEx);
    let tags = tagMatches ? tagMatches[1] : '';
    tags =
      tags.length > 0
        ? tags.split(',').map(val => {
            return parseInt(val, 10);
          })
        : [];
    let categoriesRegEx = new RegExp('categories/([0-9,]*)');
    let categoryMatches = window.location.hash.match(categoriesRegEx);
    let categories = categoryMatches ? categoryMatches[1] : '';
    categories =
      categories.length > 0
        ? categories.split(',').map(val => {
            return parseInt(val, 10);
          })
        : [];
    return {
      blog: blog,
      categories: FW.store.get('blogCategories-' + blog.get('id')) || [],
      tags: FW.store.get('blogTags-' + blog.get('id')) || [],
      posts: blog.get('posts') || [],
      recentPosts: FW.store.get('blogRecentPosts-' + blog.get('id')) || [],
      checkedTags: !this.state ? tags : this.state.checkedTags,
      checkedCategories: !this.state ? categories : this.state.checkedCategories
    };
  }

  changeCategory(category) {
    let checkedCategories = _.clone(this.state.checkedCategories) || [];
    if (_.indexOf(checkedCategories, category.get('id')) >= 0) {
      checkedCategories = _.without(checkedCategories, category.get('id'));
    } else {
      checkedCategories.push(category.get('id'));
    }
    let hash = _.clone(window.location.hash);
    hash = hash.replace(
      '/categories/' + this.state.checkedCategories.join(','),
      ''
    );
    if (checkedCategories.length > 0) {
      window.location.hash =
        hash + '/categories/' + checkedCategories.join(',');
    } else {
      window.location.hash = hash;
    }
    this.setState({
      checkedCategories: checkedCategories,
      loading: true
    });
    this.state.posts.addQuery({
      tags: this.state.checkedTags.length > 0 ? this.state.checkedTags : null,
      categories: checkedCategories.length > 0 ? checkedCategories : null
    });
    this.state.posts.fetch().then(() => {
      this.setState({
        loading: false
      });
    });
  }

  changeTag(tag) {
    let checkedTags = _.clone(this.state.checkedTags) || [];
    if (_.indexOf(checkedTags, tag.get('id')) >= 0) {
      checkedTags = _.without(checkedTags, tag.get('id'));
    } else {
      checkedTags.push(tag.get('id'));
    }
    let hash = _.clone(window.location.hash);
    hash = hash.replace('/tags/' + this.state.checkedTags.join(','), '');
    if (checkedTags.length > 0) {
      window.location.hash = hash + '/tags/' + checkedTags.join(',');
    } else {
      window.location.hash = hash;
    }
    this.setState({
      checkedTags: checkedTags,
      loading: true
    });
    this.state.posts.addQuery({
      tags: checkedTags.length > 0 ? checkedTags : null,
      categories:
        this.state.checkedCategories.length > 0
          ? this.state.checkedCategories
          : null
    });
    this.state.posts.fetch().then(() => {
      this.setState({
        loading: false
      });
    });
  }

  pageChanged = num => {
    $('body,html').animate({
      scrollTop: $(this._top).offset().top - 250
    });
    this.state.posts.getPage(num, () => {
      this.forceUpdate();
    });
  };

  searchPosts = e => {
    clearTimeout(this.searchTimeout);
    let value = e.target.value;
    this.searchTimeout = setTimeout(() => {
      this.state.posts.search(value, true, 'or', () => {
        this.forceUpdate();
      });
    }, 300);
  };

  render() {
    let posts = this.state.posts.map(post => {
      let imageId = post.get('thumbnail_image')
        ? post.get('thumbnail_image')
        : post.get('featured_image');
      let backgroundFile = imageId ? FWFile.findOrCreate({id: imageId}) : null;
      let background = backgroundFile
        ? 'url(' + backgroundFile.helper.thumbnailUrl(800) + ')'
        : null;
      let blogPreviewClass =
        (backgroundFile ? 'col-md-9' : 'col-md-12') + ' post-content';

      let showFullPost = this.props.section.prop(
        'display_full_posts_in_preview'
      );

      let displayDate = post.get('post_time').endsWith('00:00:00') ? moment(post.get('post_time')) : moment
        .utc(post.get('post_time'))
        .local();

      const showAllLineBreaks = (this.props.section && this.props.section.prop('show_all_line_breaks')) || this.state.blog.get('show_all_linebreaks_on_index');

      return (
        <div className="row post" key={`post-${post.get('id')}`}>
          {backgroundFile ? (
            <div className="col-md-3">
              <div style={{height: 175}}>
                <div
                  className="featured-image-wrapper"
                  role="img"
                  aria-label={backgroundFile ? backgroundFile.get('title') : null}
                  style={{
                    backgroundImage: background,
                    backgroundSize: post.prop('display_entire_thumbnail_image') ? 'contain' : null,
                    backgroundRepeat: 'no-repeat'
                  }}
                >
                  <div className="featured-image-overlay"></div>
                </div>
              </div>
            </div>
          ) : null}
          <div
            className={blogPreviewClass}
            style={{height: showFullPost ? 'auto' : null}}
          >
            <h2>
              <a href={post.getUrl()}>{post.get('title')}</a>
              <br />
              <small>
                {this.state.blog.get('hide_authors_name') ? null : post.author}
                {!this.state.blog.get('hide_authors_name') && !this.state.blog.get('hide_dates') ? ' - ' : null}
                {this.state.blog.get('hide_dates') ? null : <span>
                  <span>
                    {displayDate
                      .format('MMM Do, YYYY')}
                  </span></span>}
              </small>
            </h2>
            {showFullPost ? (
              <InlineEditableElement
                html={post.get('content')}
                inlineEditingEnabled={false}
              />
            ) : (
              <div className="post-content-new" style={{height: 150}}>
                <p dangerouslySetInnerHTML={{__html: post.getPreview(null, showAllLineBreaks)}}></p>
              </div>
            )}
          </div>
          <span className="post-read-more">
            <a href={post.getUrl()} className="btn btn-default">
              {showFullPost ? 'View Post' : 'Read More'}
            </a>
          </span>
        </div>
      );
    });

    let recentPosts = this.state.recentPosts.map(post => {
      return (
        <li style={{whiteSpace: 'nowrap'}} key={`post-${post.get('id')}`}>
          <a
            href={`/blog/${this.state.blog.get('slug')}/${post.get('slug')}`}
            style={{
              position: 'relative',
              top: 5,
              display: 'inline-block',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {post.get('title')}
          </a>
        </li>
      );
    });

    let categories = this.state.categories.map(category => {
      return (
        <div key={`category-${category.get('id')}`}>
          <label>
            <input
              type="checkbox"
              checked={
                _.indexOf(this.state.checkedCategories, category.get('id')) >= 0
              }
              onChange={this.changeCategory.bind(this, category)}
            />{' '}
            {category.get('title')}
          </label>
        </div>
      );
    });

    let tags = this.state.tags.map(tag => {
      return (
        <div key={`tag-${tag.get('id')}`}>
          <label>
            <input
              type="checkbox"
              checked={_.indexOf(this.state.checkedTags, tag.get('id')) >= 0}
              onChange={this.changeTag.bind(this, tag)}
            />{' '}
            {tag.get('title')}
          </label>
        </div>
      );
    });

    return (
      <div>
        <div className="col-md-9 blog-post-list" ref={c => (this._top = c)}>
          {posts}
          {this.props.section.prop('auto_load_more') ? (
            <div ref={c => (this._bottom = c)}></div>
          ) : (
            <div style={{textAlign: 'center'}}>
              <Pagination
                activePage={this.state.posts.pagination.number}
                itemsCountPerPage={this.state.posts.pagination.size}
                totalItemsCount={this.state.posts.pagination.total}
                pageRangeDisplayed={5}
                onChange={this.pageChanged}
              />
            </div>
          )}
        </div>
        <div className="col-md-3">
          <h4>Search</h4>
          <div className="form-group">
            <input
              className="form-control"
              placeholder="Enter your search..."
              aria-label="Search Blog Posts"
              onChange={this.searchPosts}
            />
          </div>
          <a
            className="btn btn-primary btn-sm"
            href={'/feeds/blogs/' + this.state.blog.get('id')}
            target="_blank"
            style={{float: 'right', marginTop: -4}}
            aria-label="Blog RSS Feed"
            role="button"
          >
            <span className="fa fa-rss" role="presentation"></span>
          </a>
          <h4>Recent Posts</h4>
          <div>
            <ul>{recentPosts}</ul>
          </div>
          <h4>Categories</h4>
          <div>{categories}</div>
          <h4>Tags</h4>
          <div>{tags}</div>
        </div>
        <br style={{width: '100%', clear: 'both'}} />
      </div>
    );
  }
}

export default BlogView;
